export default "__VITE_ASSET__962a33fa__$_?component__"